import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyCUVR6TvaGxMMFrMvHUqSmfExmdHnazpwE',
  authDomain: 'ayokerja.achristoph.com',
  databaseURL: 'https://ayokerja-app.firebaseio.com',
  projectId: 'ayokerja-app',
  storageBucket: 'ayokerja-app.appspot.com',
  messagingSenderId: '120496643538'
};

firebase.initializeApp(config);
const settings = { /* your settings... */ timestampsInSnapshots: true };

const db = firebase.firestore();
const FieldValue = firebase.firestore.FieldValue;
const auth = firebase.auth();

db.settings(settings);

function signInWithGoogle() {
  firebase.auth().signInWithRedirect(new firebase.auth.GoogleAuthProvider());
}

function getSignInResult() {
  return firebase.auth().getRedirectResult();

  // .catch(function(error) {
  //   // Handle Errors here.
  //   var errorCode = error.code;
  //   var errorMessage = error.message;
  //   // The email of the user's account used.
  //   var email = error.email;
  //   // The firebase.auth.AuthCredential type that was used.
  //   var credential = error.credential;
  //   // ...
  // });
}
const collections = {
  usersCollection: db.collection('users'),
  employeeCollection: db.collection('employee'),
  employerCollection: db.collection('employer')
};
// usersCollection
//   .doc('1')
//   .get()
//   .then(res => {
//     const data = res.data();
//     console.log(data);
//   });

export { db, auth, FieldValue, signInWithGoogle, getSignInResult, collections };
